//This file is generated from c# do not modify, any changes will be overridden when re-generated.
  import { ModelBase } from "../../pillar/common/models/ModelBase";
  
  
  export class CodeSystemVersionListModel extends ModelBase {
      static readonly $typeName = 'CodeSystemVersionListModel';
      public codeSystemName: string;
      public versionName: string;
      public releaseDate: Date;
      public key: string;
      public status: string;
      public url: string;
      public projectName: string;

  }



// WEBPACK FOOTER //
// ./src/app/vocabulary/models/CodeSystemVersionListModel.ts